import { initAccordion } from '../../common/accordion';

export function domReady() {
    initAccordion('[data-faq-accordion-button]');
}
